var _rect, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#c7c7c76a",
    fillOpacity: 0.61
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0244 6.3715C10.5496 5.59751 11.7338 4.31517 12.5895 3.57604C13.0642 3.16601 13.5829 3.42801 13.7386 4.03565C14.2774 3.59811 14.9752 3.60281 15.1541 4.27343C15.5565 5.78109 15.5641 8.62308 15.5032 9.65879C15.422 11.0386 14.9039 11.7958 14.3263 12.3373C13.7487 12.8788 13.0682 13.0272 12.6217 13.0678C12.1753 13.1084 11.2825 13.2302 10.3491 12.5808C9.41565 11.9315 8.84746 10.3487 8.96922 9.25295C9.09098 8.15719 9.25331 7.50785 10.0244 6.3715Z",
    fill: "url(#paint0_radial_2668_1296)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1869 7.35572C19.0854 7.61606 20.6709 8.34601 21.6382 8.93142C22.1749 9.25618 22.086 9.83046 21.5562 10.1663C22.1388 10.5435 22.35 11.2086 21.7675 11.586C20.458 12.4346 17.7574 13.3201 16.7536 13.5822C15.4162 13.9314 14.5359 13.6726 13.8425 13.2906C13.149 12.9086 12.7975 12.3072 12.621 11.8952C12.4444 11.4832 12.0527 10.6717 12.3819 9.58327C12.711 8.49487 14.0407 7.46539 15.1205 7.24258C16.2002 7.01978 16.8679 6.9735 18.1869 7.35572Z",
    fill: "url(#paint1_radial_2668_1296)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7733 15.4229C19.8033 16.3578 19.599 18.0913 19.3412 19.1922C19.1982 19.8029 18.6245 19.8958 18.1414 19.4958C17.9627 20.1664 17.3954 20.5728 16.8564 20.1354C15.6448 19.1522 13.9681 16.8575 13.4086 15.9838C12.6632 14.8197 12.6374 13.9026 12.7864 13.125C12.9353 12.3475 13.3987 11.8273 13.736 11.5321C14.0733 11.2369 14.724 10.6136 15.8609 10.5903C16.9977 10.567 18.3877 11.5135 18.9333 12.4715C19.4788 13.4296 19.7292 14.0503 19.7733 15.4229Z",
    fill: "url(#paint2_radial_2668_1296)",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5911 19.4244C11.7113 19.7419 9.99951 20.0833 8.87279 20.1783C8.24774 20.231 7.9821 19.7142 8.21331 19.1311C7.52023 19.1683 6.95848 18.7544 7.20788 18.1067C7.76856 16.6504 9.43285 14.3467 10.0909 13.5446C10.9677 12.476 11.8319 12.168 12.6175 12.0694C13.403 11.9708 14.0408 12.2508 14.4258 12.4803C14.8109 12.7099 15.6047 13.1362 15.9782 14.2102C16.3517 15.2842 15.881 16.8986 15.1385 17.7135C14.3959 18.5285 13.8829 18.9584 12.5911 19.4244Z",
    fill: "url(#paint3_radial_2668_1296)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56601 13.8304C5.9922 13.0917 5.13855 11.5692 4.70003 10.527C4.45676 9.94882 4.86622 9.53647 5.49223 9.57618C5.2426 8.92853 5.4627 8.26636 6.15579 8.30339C7.714 8.38664 10.4193 9.25758 11.3854 9.63558C12.6727 10.1392 13.2327 10.866 13.5692 11.5826C13.9057 12.2992 13.8366 12.9923 13.7372 13.4295C13.6379 13.8666 13.4777 14.7533 12.5717 15.4404C11.6657 16.1275 9.98486 16.1788 8.98036 15.7244C7.97585 15.2699 7.40845 14.9149 6.56601 13.8304Z",
    fill: "url(#paint4_radial_2668_1296)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2668_1296",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.37985 -7.508 8.00565 -3.86762 14.0422 11.2821)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D26378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC2C2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2668_1296",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.37985 -7.508 8.00565 -3.86762 14.0422 11.2821)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D26378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC2C2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2668_1296",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.37985 -7.508 8.00565 -3.86762 14.0422 11.2821)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D26378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC2C2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2668_1296",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.37985 -7.508 8.00565 -3.86762 14.0422 11.2821)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D26378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC2C2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2668_1296",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.37985 -7.508 8.00565 -3.86762 14.0422 11.2821)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D26378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC2C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoChain);
export default __webpack_public_path__ + "static/media/logo-chain.f6dbfc646d571094c3e2572bbd02a661.svg";
export { ForwardRef as ReactComponent };